export const LOADING_BUDGET_ACTIONS = "LOADING_BUDGET_ACTIONS";
export const SAVE_LOADING_BUDGET_ACTIONS = "SAVE_LOADING_BUDGET_ACTIONS";
export const GET_BUDGETS = "GET_BUDGETS";
export const CREATE_BUDGET = "CREATE_BUDGET";
export const DELETE_BUDGET = "DELETE_BUDGET";
export const FORM_FAIL = "FORM_FAIL";
export const BUDGET_ACTIONS_FAIL = "BUDGET_ACTIONS_FAIL";
export const GET_ANNUAL_BUDGETS = "GET_ANNUAL_BUDGETS";
export const CREATE_ANNUAL_BUDGET = "CREATE_ANNUAL_BUDGET";
export const CLEAR_ANNUAL_BUDGETS = "CLEAR_ANNUAL_BUDGETS";
export const SEND_EMAIL_LOADING = "SEND_EMAIL_LOADING";
export const SEND_EMAIL_SUCCESS = "SEND_EMAIL_SUCCESS";
export const SEND_EMAIL_FAIL = "SEND_EMAIL_FAIL";
export const UPDATE_MONTHLY_BUDGET_EXPENDITURE = "UPDATE_MONTHLY_BUDGET_EXPENDITURE";
export const UPDATE_MONTHLY_BUDGET_EXPENDITURE_LOADING = "UPDATE_MONTHLY_BUDGET_EXPENDITURE_LOADING";
export const UPDATE_MONTHLY_BUDGET_EXPENDITURE_FAIL = "UPDATE_MONTHLY_BUDGET_EXPENDITURE_FAIL";